import {useTranslation} from 'react-i18next';

import {config} from '@/config';
import {
  SortingOptions,
  type SortingOption as SortingOptionType,
} from '@/modules/common/context/QueryParams/models';
import {useCurrentPage} from '@/modules/common/hooks/useCurrentPage';

type SortingOption = {
  label: string;
  value: string;
  hint: string;
  description: string;
};

const translationKeyBySortingOption: Record<SortingOptionType, string> = {
  [SortingOptions.priceAsc]: 'priceAscending',
  [SortingOptions.ratingAsc]: 'ratingAscending',
  [SortingOptions.ratingDesc]: 'ratingDescending',
  [SortingOptions.categoryAsc]: 'categoryAsccending',
  [SortingOptions.categoryDesc]: 'categoryDescending',
  [SortingOptions.bd4Desc]: 'popularityDescending',
  [SortingOptions.durationDesc]: 'durationDescending',
  [SortingOptions.departureDateAsc]: 'departureDateAscending',
};

export const useSortingOptions = (): Array<SortingOption> => {
  const {t} = useTranslation('general');
  const currentPage = useCurrentPage();

  return config.sorting.optionsByPage[currentPage].map((value) => ({
    value,
    label: t(
      `sortingDropdown.options.${translationKeyBySortingOption[value]}.label`
    ),
    hint: t(
      `sortingDropdown.options.${translationKeyBySortingOption[value]}.hint`,
      {defaultValue: ''}
    ),
    description: t(
      `sortingDropdown.options.${translationKeyBySortingOption[value]}.description`,
      {defaultValue: ''}
    ),
  }));
};
